import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/input/input-element.tsx
import { Slot } from "@radix-ui/react-slot";
import React, { forwardRef } from "react";
var InputElement = forwardRef(
  ({ placement: _placement, asChild = false, className, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";
    return /* @__PURE__ */ React.createElement(
      Comp,
      {
        ref,
        className: cn(
          "absolute inset-y-0 z-10 flex w-10 shrink-0 items-center justify-center px-2 text-inherit",
          className
        ),
        ...props
      }
    );
  }
);
var InputLeftElementComponent = forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ React.createElement(
    InputElement,
    {
      ref,
      placement: "left",
      className: cn("left-px py-px", className),
      ...props
    }
  );
});
var InputLeftElement = Object.assign(InputLeftElementComponent, {
  id: "InputLeftElement"
});
var InputRightElementComponent = forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ React.createElement(
    InputElement,
    {
      ref,
      placement: "right",
      className: cn("right-px py-px", className),
      ...props
    }
  );
});
var InputRightElement = Object.assign(InputRightElementComponent, {
  id: "InputRightElement"
});

export {
  InputLeftElement,
  InputRightElement
};
